import { styled } from '@mui/system';
import { MAIN } from 'src/config-global';

export const PageContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  height: MAIN.FULL_H,
  backgroundColor: theme.palette.background.default,
  overflow: 'hidden',
  flexGrow: 1,
  '&.fullHeight': {
    height: '100vh',
  },
  '&.hasAlert': {
    height: MAIN.FULL_H_WITH_ALERT,
  },
}));
